import { useEffect } from "react";
// import axios from "axios";
import axios from "lib/axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/auth";
import {
  handleget_headers_params,
  initFilterUrlLikelihood,
  initFilterUrl,
  showToastr,
  redirect,
  clearStorage,
} from "pages/Utils";

export default function Callback() {
  const navigate = useNavigate();

  const { login_session, login, get_me } = useAuth({
    middleware: "guest",
    redirectIfAuthenticated: "/dashboard",
    // onRequestDone: handleRequestDone,
  });

  const CallbackMe = async (event) => {
    // event.preventDefault();

    // setbtn_loading(true);
    get_me();
  };

  useEffect(() => {
    CallbackMe();
    // axios(handleget_headers_params())
    //   .get(`me`, {
    //     // withCredentials: true,
    //   })
    //   .then((res) => {
    //     localStorage.setItem("user", JSON.stringify(res.data));
    //     // navigate("/dashboard");
    //   })
    //   .catch(() => {
    //     console.log("gagal login");
    //     navigate("/login");
    //   });
  }, []);

  return <div>Loading...</div>;
}
